import { Grid } from "@material-ui/core"
import Container from '../../components/layout/Container'
import BoasVindas from '../../components/data_display/BoasVindas'
import Card from "../../components/Surfaces/Card"
import ImgLocalizacao from '../../assets/img/location.png'
import ImgLogin from '../../assets/img/authentication.png'
import webConfig from '../../webconfig.json'

export default function Home(props) {
  return (
    <Container
      title={webConfig.nomeApresentavelSistema}>
      <div id="ContainerPage">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <BoasVindas />
          </Grid>
        </Grid>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Card
              image={ImgLogin}
              title="Login"
              description="Entrar no sistema TCE-Comunica."
              link={`/Dashboard`}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Card
              image={ImgLocalizacao}
              title="Localização"
              description={
                <ul className="localizacao">
                  <li><span><strong>Endereço:</strong> </span> Av. Ubirajara Berocan Leite, Nº. 640 St. Jaó, Goiânia – GO</li>
                  <li><span><strong>CEP:</strong> </span> 74.674-015 <span className="cpostal">C.Postal: </span> 12.824</li>
                  <li><span><strong>Local:</strong> </span> Sede do TCE-GO, Piso térreo, bloco C</li>
                  <li><span><strong>Telefones:</strong></span> (62) 3228-2814 e (62) 3228-2894</li>
                  <li>Atendimento ao público externo, das 08:00 às 18:00 horas, de segunda a sexta-feira</li>
                  <li><span><strong>E-mail:</strong> </span> <a href="mailto:informatica@tce.go.gov.br">informatica@tce.go.gov.br</a></li>
                </ul>
              }
              additionalInfo={
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4545.914200139433!2d-49.22114415044623!3d-16.64467905513382!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x89f028a42a813b91!2sTCE+-+Tribunal+de+Contas+do+Estado+de+Goi%C3%A1s!5e0!3m2!1spt-BR!2sbr!4v1493989061022"
                  width="100%"
                  height="300"
                  frameBorder="0"
                  allowFullScreen=""
                  title="Mapa da localização do TCE-GO"
                ></iframe>
              }
            />
          </Grid>
        </Grid>
      </div>
      <br /><br /><br /><br />
    </Container >

  )
}